// extracted by mini-css-extract-plugin
export default {"memtradeWrapper":"Memtrade_memtradeWrapper__OgAp6","slideIn":"Memtrade_slideIn__dKpNI"};